export const RELEASE_VERSION = import.meta.env?.VITE_RELEASE_VERSION;

export const ENVIRONMENT: 'local' | 'staging' | 'prod' = import.meta.env?.VITE_ENVIRONMENT;
export const DATADOG_APPLICATION_NAME = import.meta.env?.VITE_DATADOG_APPLICATION_NAME;
export const DATADOG_APPLICATION_ID = import.meta.env?.VITE_DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = import.meta.env?.VITE_DATADOG_CLIENT_TOKEN;
export const DATADOG_SITE = import.meta.env?.VITE_DATADOG_SITE;
export const CONFIG_CAT_SDK_KEY = import.meta.env?.VITE_CONFIG_CAT_SDK_KEY;
export const NUVO_LICENSE_KEY = import.meta.env?.VITE_NUVO_LICENSE_KEY;
export const NUVO_DEV_LICENSE_KEY = import.meta.env?.VITE_NUVO_DEV_LICENSE_KEY;
